/*
 *
 * Dataset reducer
 *
 */
import produce from 'immer';
import { GET_DATASET_DATA_REQUEST, GET_DATASET_DATA_SUCCESS, GET_DATASET_DATA_FAILURE, ADD_ROW_REQUEST, ADD_ROW_SUCCESS, ADD_ROW_FAILURE, EDIT_ROW_SUCCESS, EDIT_ROW_FAILURE, EDIT_ROW_REQUEST, GET_ROW_DATA_REQUEST, GET_ROW_DATA_SUCCESS, GET_ROW_DATA_FAILURE, LOAD_FILES_REQUEST, LOAD_FILES_SUCCESS, LOAD_FILES_FAILURE, CLEAR_ROW_DATA_SUCCESS, } from './constants';
import { hasDrafts } from '../../utils/meta';
export var initialState = {
    dataset: {},
    columns: [],
    rowData: {},
    meta: {},
    files: [],
    filesMeta: {},
    saveRow_loading: false,
    saveRow_error: false,
    getRow_loading: false,
    getRow_error: false,
    dataset_loading: false,
    dataset_error: false,
    isDraft: false,
};
function datasetRowReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case ADD_ROW_REQUEST:
                state.saveRow_loading = true;
                state.saveRow_error = false;
                break;
            case ADD_ROW_SUCCESS:
                state.saveRow_loading = false;
                state.saveRow_error = false;
                break;
            case ADD_ROW_FAILURE:
                state.saveRow_loading = false;
                state.saveRow_error = true;
                break;
            case EDIT_ROW_REQUEST:
                state.saveRow_loading = true;
                state.saveRow_error = false;
                break;
            case EDIT_ROW_SUCCESS:
                state.saveRow_loading = false;
                state.saveRow_error = false;
                break;
            case EDIT_ROW_FAILURE:
                state.saveRow_loading = false;
                state.saveRow_error = true;
                break;
            case GET_DATASET_DATA_REQUEST:
                state.dataset_loading = true;
                state.dataset_error = false;
                break;
            case GET_DATASET_DATA_SUCCESS:
                state.dataset = action.datasetMeta;
                state.columns = action.datasetMeta.fields;
                state.dataset_loading = false;
                state.dataset_error = false;
                break;
            case GET_DATASET_DATA_FAILURE:
                state.dataset_loading = false;
                state.dataset_error = true;
                break;
            case GET_ROW_DATA_REQUEST:
                state.getRow_loading = true;
                state.getRow_error = false;
                break;
            case GET_ROW_DATA_SUCCESS:
                state.rowData = action.rowData;
                state.meta = action.meta;
                state.isDraft = hasDrafts(action.meta);
                state.getRow_loading = false;
                state.getRow_error = false;
                break;
            case GET_ROW_DATA_FAILURE:
                state.getRow_loading = false;
                state.getRow_error = action.err;
                break;
            case LOAD_FILES_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_FILES_SUCCESS:
                state.files = action.files;
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case CLEAR_ROW_DATA_SUCCESS:
                state.rowData = {};
                state.meta = {};
                break;
            default:
                break;
        }
    });
}
export default datasetRowReducer;
